import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DynamicField } from 'src/app/modules/core/components/fields/dynamic-field';
import { Document, DocumentSchema } from 'src/app/modules/core/store/models/document.model';
import { View } from 'src/app/modules/management/store/workflow';
import { Dataset } from '../../store/models/dataset.model';
import { GUID_EMPTY } from '@app/core/constants';
import { ModalComponent } from '../../components/modal/modal.component';
import { TranslatePipe } from '@ngx-translate/core';

import { DynamicFieldDirective } from '../../components/fields/dynamic-field.directive';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'topo-workflow-transition-form',
  imports: [ModalComponent, TranslatePipe, DynamicFieldDirective, FlexLayoutModule],
  templateUrl: './workflow-transition-form.component.html',
  styleUrls: ['./workflow-transition-form.component.scss']
})
export class WorkflowTransitionFormComponent implements OnInit, OnDestroy {
  @Input() isActive: boolean;
  @Input() editView: View;
  @Input() dataset: Dataset = null;
  @Input() document: Document = null;
  @Input() schema: DocumentSchema = null;
  @Input() workflowStepUId: string;
  @Output() save: EventEmitter<DynamicField[]> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  guidEmpty = GUID_EMPTY;

  controls: DynamicField[] = [];
  private destroy$ = new Subject<void>();
  errorMessage$: Observable<string>;

  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {}

  onClose(): void {
    this.close.emit();
  }

  saveClick() {
    this.save.emit(this.controls);
  }
}
